import { Title } from "./Components/Title";
import logo from "./images/logo.png";
import React, { useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";

// TypeScript workaround for React 19 compatibility
const ReCAPTCHAComponent = ReCAPTCHA as any;

export const Contact = () => {
    const captchaRef = useRef<ReCAPTCHA>(null);
    const [token, setToken] = useState<string | undefined>(undefined);
    const siteKey = process.env.REACT_APP_CT_RECAPTCHA_KEY ? process.env.REACT_APP_CT_RECAPTCHA_KEY : "";
    const [name, setName] = useState<string | undefined>(undefined);
    const [email, setEmail] = useState<string | undefined>(undefined);
    const [subject, setSubject] = useState<string | undefined>(undefined);
    const [message, setMessage] = useState<string | undefined>(undefined);
    const [thanks, setThanks] = useState<string | undefined>(undefined);
    const [error, setError] = useState<string | undefined>(undefined);

    const onChange = (v: any) => {
        setToken(v);
    };

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        
        const isDevelopment = process.env.NODE_ENV === 'development';
        
        let currentToken: string;
        if (!isDevelopment) {
            // Production: Use reCAPTCHA
            currentToken = captchaRef.current?.getValue() || '';
            setToken(currentToken);
            captchaRef.current?.reset();
        } else {
            // Development: Skip reCAPTCHA
            currentToken = 'dev-skip-token';
            setToken(currentToken);
        }

        if (process.env.REACT_APP_API_URL) {
            setThanks(isDevelopment ? "Sending email (dev mode)..." : "Checking captcha.");
            const recapVerify = await fetch(process.env.REACT_APP_API_URL, {
                method: "post",
                body: JSON.stringify({ token: currentToken, name, email, subject, message }),
                headers: {
                    "Content-Type": "application/json",
                },
            });
            if (recapVerify && recapVerify.status === 200) {
                setThanks("Thank you.  We'll reach out to you soon.");
            } else {
                if (!isDevelopment) {
                    captchaRef.current?.reset();
                    setToken(undefined);
                }
                setError("Invalid Captcha. Please try again.");
            }
        }
    };

    return (
        <div className="contact-form-wrapper">
            <div className="projects-logo">
                <a href="/">
                    <img src={logo} alt="Video is Social logo" />
                </a>
            </div>
            <div className="contact-form">
                <Title text="Contact" />
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="nameInput">Name</label>
                        <input type="text" required className="form-control" id="nameInput" size={40} onChange={(v) => setName(v.target.value)} />
                    </div>
                    <div className="form-group">
                        <label htmlFor="emailInput">Email address</label>
                        <input type="email" required className="form-control" id="emailInput" size={40} onChange={(v) => setEmail(v.target.value)} />
                    </div>
                    <div className="form-group">
                        <label htmlFor="subjectInput">Subject</label>
                        <input type="text" className="form-control" id="subjectInput" size={40} onChange={(v) => setSubject(v.target.value)} />
                    </div>
                    <div className="form-group">
                        <label htmlFor="messageInput">Message</label>
                        <textarea required className="form-control" id="messageInput" rows={10} onChange={(v) => setMessage(v.target.value)}></textarea>
                    </div>
                    {error ? <div className="error">{error}</div> : <></>}
                    {thanks ? (
                        <div className="thanks">{thanks}</div>
                    ) : (
                        <>
                            <ReCAPTCHAComponent sitekey={siteKey} ref={captchaRef} id="recaptcha" onChange={onChange} />
                            <input type="submit" value="Send" className="" disabled={process.env.NODE_ENV === 'development' ? (!email || !message) : (!token || !email || !message)} />
                        </>
                    )}
                </form>
            </div>
        </div>
    );
};
